export const studyModulesLoading = ({store}) => store.studyModulesReducer.loading;

export const studyModulesError = ({store}) => store.studyModulesReducer.error;

export const studyModulesData = ({store}) => store.studyModulesReducer.data;


export const specificModuleLoading = ({store}) => store.specificReducer.loading;
export const specificModuleError = ({store}) => store.specificReducer.error;
export const specificModuleData = ({store}) => store.specificReducer.data;